import React from "react";
import { withStyles } from "material-ui/styles";
import { withRouter } from "react-router-dom";
import Typography from "material-ui/Typography";
import CreditCardIcon from "material-ui-icons/CreditCard";
import MonetizationOnIcon from "material-ui-icons/MonetizationOn";
import Button from "material-ui/Button";
import Divider from "material-ui/Divider";
import { grey } from "material-ui/colors";

const styles = theme => {
  return {
    root: {
      flexGrow: 1,
      display: "flex",
      flexDirection: "row",
      paddingRight: 8,
      paddingLeft: 16,
      alignItems: "center"
    },
    icon: {
      color: grey[500],
      marginRight: 8
    },
    button: {
      flexGrow: 1
    },
    label: {
      color: grey[700],
      flexGrow: 1
    }
  };
};

const methods = [
  { name: "none", nice: "Monthly" },
  { name: "braintree", nice: "Credit card" }
];

const AccountPaymentMethodFilterButtons = props => {
  const { classes, history } = props;

  const renderButtons = () => {
    return methods.map((m, i) => (
      <Button
        key={i}
        color="primary"
        onClick={() => history.push(`/accounts?paymentMethod=${m.name}`)}
        className={classes.button}
      >
        {m.name === "none" ? (
          <MonetizationOnIcon className={classes.icon} />
        ) : (
          <CreditCardIcon className={classes.icon} />
        )}
        {m.nice}
      </Button>
    ));
  };

  return (
    <div>
      <div className={classes.root}>
        <Typography type="body1" className={classes.label}>
          Payment method:
        </Typography>
        {renderButtons()}
      </div>
      <Divider />
    </div>
  );
};

export { AccountPaymentMethodFilterButtons };

export default withStyles(styles, {
  name: "AccountPaymentMethodFilterButtons"
})(withRouter(AccountPaymentMethodFilterButtons));



// WEBPACK FOOTER //
// ./src/AccountPaymentMethodFilterButtons.js